//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const EmployeeFundsDashboardConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/ewa/dashboard",
      component: FuseLoadable({
        loader: () => import("./ewaDashboard.js")
      })
    }
  ]
  //end routes
};
